import { render, staticRenderFns } from "./FormComponentConfig.vue?vue&type=template&id=30ce9c5c&scoped=true"
import script from "./FormComponentConfig.vue?vue&type=script&lang=js"
export * from "./FormComponentConfig.vue?vue&type=script&lang=js"
import style0 from "./FormComponentConfig.vue?vue&type=style&index=0&id=30ce9c5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ce9c5c",
  null
  
)

export default component.exports